import { D3ModalDialogComponent } from '@d3/ui/shared-components';
import { firstValueFrom } from 'rxjs';

export interface DialogLabels {
  confirmLabel: string;
  cancelLabel: string;
}

export async function existingApplicationDraft(modal: D3ModalDialogComponent, labels: DialogLabels) {
  return openExistingApplicationModal(
    modal,
    labels,
    `Application for this child already exists in your <b>Draft application(s)</b> tab. Would you like to continue the application?`
  );
}

export async function existingApplicationSubmitted(modal: D3ModalDialogComponent, labels: DialogLabels) {
  return openExistingApplicationModal(
    modal,
    labels,
    `Application for this child already exists in your <b>Submitted application(s)</b> tab. Would you like to view the application?`
  );
}

export async function existingApplicationRemoved(modal: D3ModalDialogComponent, labels: DialogLabels) {
  return openExistingApplicationModal(
    modal,
    labels,
    `Application for this child already exists in your <b>Recently removed application(s)</b> tab. Would you like to restore it?`
  );
}

async function openExistingApplicationModal(modal: D3ModalDialogComponent, labels: DialogLabels, message: string) {
  modal.dialogContent = {
    headerText: 'Application already exists',
    bodyText: message,
    confirmButtonText: labels.confirmLabel,
    cancelButtonText: labels.cancelLabel,
  };

  return firstValueFrom(modal.openModal('information', null, true));
}
